import {IGraphMythPass} from "./ResponseBean";
import {MythPassRarity} from "../constant/CommonConstant";

export interface IMyMythPasses {
    classicPassTokenIds: number[],
    goldenPassTokenIds: number[]
}

export function convertToMyMythPasses(graphMythPasses: IGraphMythPass[] | undefined): IMyMythPasses {
    const myMythPasses: IMyMythPasses = {classicPassTokenIds: [], goldenPassTokenIds: []};
    if (graphMythPasses && graphMythPasses.length > 0) {
        graphMythPasses.forEach(value => {
            const tokenId = Number.parseInt(value.id);
            if (value.rarity === MythPassRarity.CLASSIC) {
                myMythPasses.classicPassTokenIds.push(tokenId)
            } else if (value.rarity === MythPassRarity.GOLDEN) {
                myMythPasses.goldenPassTokenIds.push(tokenId);
            }
        });
    }
    return myMythPasses;
}

